import { Component, OnInit } from '@angular/core';
/* tslint:disable */

@Component({
  selector: 'nns-video-loader',
  styles: [`
      .spinner {
        margin: 200px auto;
        width: 40px;
        height: 40px;
        position: relative;
        text-align: center;

        -webkit-animation: rotate 2.0s infinite linear;
        animation: rotate 2.0s infinite linear;
      }

      .dot1, .dot2 {
        width: 60%;
        height: 60%;
        display: inline-block;
        position: absolute;
        top: 0;
        border-radius: 100%;

        -webkit-animation: bounce 2.0s infinite ease-in-out;
        animation: bounce 2.0s infinite ease-in-out;
        background-color: #0096a7;
      }

      .dot2 {
        top: auto;
        bottom: 0px;
        -webkit-animation-delay: -1.0s;
        animation-delay: -1.0s;
      }

      @-webkit-keyframes rotate {
        100% {
          -webkit-transform: rotate(360deg)
        }
      }

      @keyframes rotate {
        100% {
          transform: rotate(360deg);
          -webkit-transform: rotate(360deg)
        }
      }

      @-webkit-keyframes bounce {
        0%, 100% {
          -webkit-transform: scale(0.0)
        }
        50% {
          -webkit-transform: scale(1.0)
        }
      }

      @keyframes bounce {
        0%, 100% {
          transform: scale(0.0);
          -webkit-transform: scale(0.0);
        }
        50% {
          transform: scale(1.0);
          -webkit-transform: scale(1.0);
        }
      }

      div.nimbus-app-loading {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
      }
  `],
  template: `
    <div class="animated-container" ng-hide="true">
      <div class="messaging">
        <div class="spinner">
          <div class="dot1"></div>
          <div class="dot2"></div>
        </div>
      </div>
    </div>
  `
})

export class VideoLoaderComponent implements OnInit {
  constructor() { }

  ngOnInit() { }
}